import React, { useEffect, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { Appearance, loadStripe } from '@stripe/stripe-js';
import { usePayment } from 'pages/support/hooks/usePayment';

type Props = { children: React.ReactNode };

const stripeTestPromise = loadStripe(
  process.env.REACT_APP_STRIPE_API_KEY as string,
);

const appearance: Appearance = {
  theme: 'flat',
  variables: {
    fontLineHeight: '1.5',
    borderRadius: '10px',
    colorBackground: '#F6F8FA',
    colorPrimaryText: '#262626',
  },
  rules: {
    '.Block': {
      backgroundColor: 'var(--colorBackground)',
      boxShadow: 'none',
      padding: '12px',
    },
    '.Input': {
      padding: '12px',
    },
    '.Input:disabled, .Input--invalid:disabled': {
      color: 'lightgray',
    },
    '.Tab': {
      padding: '10px 12px 8px 12px',
      border: 'none',
    },
    '.Tab:hover': {
      border: 'none',
      boxShadow:
        '0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 7px rgba(18, 42, 66, 0.04)',
    },
    '.Tab--selected, .Tab--selected:focus, .Tab--selected:hover': {
      border: 'none',
      backgroundColor: '#fff',
      boxShadow:
        '0 0 0 1.5px var(--colorPrimaryText), 0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 7px rgba(18, 42, 66, 0.04)',
    },
    '.Label': {
      fontWeight: '500',
    },
  },
};

function PaymentElementWrapper({ children }: Props) {
  const { clientSecret } = usePayment();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (clientSecret) {
      stripeTestPromise.then(() => setIsReady(true));
    }
  }, [clientSecret]);

  if (!isReady) {
    return null;
  }

  return (
    <Elements
      stripe={stripeTestPromise}
      options={{ locale: 'en', clientSecret, appearance }}
    >
      {children}
    </Elements>
  );
}

export default PaymentElementWrapper;
